import { Component, OnInit, Input } from '@angular/core';
import { environment } from 'environments/environment';

interface User {
    // provide id to automatically generate avatarUrl
    id?: number;

    // otherwise pass in avatarUrl if you got it from api
    avatarUrl?: string;

    // otherwise pass in first and last for initials
    first?: string;
    last?: string;

    // or fullName
    fullName?: string;
}

@Component({
    selector: 'user-avatar-component',
    template:
        `<div class="uac-container">
            <img *ngIf="showAvatar" class="uac-content" [src]="avatarUrl" [alt]="altText" (error)="showAvatar = false">
            <div *ngIf="!showAvatar" class="uac-content d-flex align-items-center justify-content-center">
                <div>{{ initials }}</div>
            </div>
        </div>`,
    styleUrls: ['user-avatar.component.scss']
})

export class UserAvatarComponent implements OnInit {

    @Input() user: User | undefined;
    showAvatar = false;
    avatarUrl = '';
    initials = '?';
    altText = '';

    ngOnInit() {
        this.avatarUrl = this.getAvatarUrl() + '?' + (new Date()).getTime();
        this.altText = this.getFullName();
        this.initials = this.getInitials();
        this.showAvatar = !!this.avatarUrl;
    }

    getAvatarUrl() {
        if (!this.user) {
            return '';
        }

        // prefer the user id to avoid people feeling like they need to generate the avatar url outside this component
        if (this.user.id) {
            return `${environment.AVATAR_BASE_URL}/${this.user.id}.png`;
        }

        // otherwise use api-side generated url
        if (this.user.avatarUrl) {
            return this.user.avatarUrl;
        }

        return '';
    }

    getFullName() {
        if (!this.user) {
            return '';
        }

        // use fullName if available
        if (this.user.fullName) {
            return this.user.fullName;
        }

        // otherwise build up using first and last
        return [this.user.first || '', this.user.last || ''].join(' ');
    }

    getInitials() {
        const fullName = this.getFullName();
        return fullName.split(/\s+/g).map(x => x[0]).join('');
    }
}
